import {
    Box,
    Text,
    VStack,
    HStack,
    Badge,
    Icon,
    Skeleton,
    SkeletonCircle,
    SkeletonText
  } from "@chakra-ui/react";
  import { FaArrowCircleUp } from "react-icons/fa";
  //import timeAgo from '../../utils/timeAgo';
  import dateUtils from '../../utils/formatDate';
  import { useTranslation } from "react-i18next";
  
  const UsedPointHistory = ({ usedPointsTransactions, isLoading, bgColor, textColor, iconColor  }) => {

    const savedLanguage = localStorage.getItem("i18nextLng") || "en";
    const {t} = useTranslation();

    return (
      <VStack
      width="100%"
      spacing={2}
      borderRadius="xl"
      overflowY="auto"
      maxHeight="400px"
    >
      {isLoading ? (
        // Skeleton Loader for Placeholder Effect
        Array.from({ length: 5 }).map((_, index) => (
          <Box
            key={index}
            p={4}
            borderRadius="xl"
            bg={bgColor}
            color={textColor}
            borderBottomWidth={2}
            width="100%"
          >
            {/* Main Row - Icon + Details + Points */}
            <HStack justify="space-between" align="center">
              {/* Skeleton for Icon & Date */}
              <HStack spacing={4} align="center">
                <SkeletonCircle size="6" />
                <Skeleton height="4" width="80px" />
              </HStack>
    
              {/* Skeleton for Added By Name */}
              <Skeleton height="4" width="100px" />
    
              {/* Skeleton for Points Section */}
              <HStack spacing={1} flex={2} justify="flex-end">
                <Skeleton height="8" width="40px" />
                <Skeleton height="6" width="50px" />
              </HStack>
            </HStack>
    
            {/* Skeleton for Time Ago Text */}
            <SkeletonText noOfLines={1} spacing="2" skeletonHeight="3" mt={2} />
          </Box>
        ))
      ) : Array.isArray(usedPointsTransactions) && usedPointsTransactions.length > 0 ? (
        usedPointsTransactions
          .filter((transaction) => transaction.type === "redeem" && transaction.amount !== 0) // Filter for redeem transactions
          .map((transaction) => (
            <Box
              key={transaction?.transaction_id}
              p={4}
              borderRadius="xl"
              bg={bgColor}
              color={textColor}
              borderBottomWidth={2}
              width="100%"
            >
              {/* Main Row - Icon + Details + Points */}
              <HStack justify="space-between" align="center">
                <HStack spacing={4} align="center">
                  <Icon as={FaArrowCircleUp} color={iconColor} boxSize={6} transform="rotate(45deg)" />
                  <Text fontSize="xs" fontWeight="bold">
                    {dateUtils.formatDate(transaction?.createdAt, savedLanguage)}
                  </Text>

                </HStack>
    
                <VStack align="center" spacing={1}>
                  <Text fontSize="xs" color="gray.400">{transaction?.added_by_name}</Text>
                </VStack>
    
                {/* Points Section */}
                <HStack spacing={1} flex={2} justify="flex-end">
                  <Text color={iconColor} fontSize="xl" fontWeight="bold">-{dateUtils.convertToBurmeseNumerals(transaction.points, savedLanguage)}</Text>
                  <Badge color={iconColor} px={2} py={1} borderRadius="md">{t('point')}</Badge>
                </HStack>
              </HStack>
    
              {/* Used points datetime ago */}
              <Text fontSize="xs" color="gray.500" fontWeight="semibold" mt={1}>
                {/* {transaction?.createdAt ? timeAgo(new Date(transaction.createdAt)) : "No date"} */}
                {transaction?.createdAt && dateUtils.timeAgo(new Date(transaction.createdAt), savedLanguage)}
              </Text>
            </Box>
          ))
      ) : (
        <Text color="gray.600" textAlign="center">No data found.</Text>
      )}
    </VStack>
    
    );
  };
  
  export default UsedPointHistory;
  